import { render, staticRenderFns } from "./TargetConsumptionManagement.vue?vue&type=template&id=35fe7257&scoped=true"
import script from "./TargetConsumptionManagement.vue?vue&type=script&lang=ts"
export * from "./TargetConsumptionManagement.vue?vue&type=script&lang=ts"
import style0 from "./TargetConsumptionManagement.vue?vue&type=style&index=0&id=35fe7257&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fe7257",
  null
  
)

export default component.exports